module.exports = __webpack_public_path__ + "img/11.79d64c51.png";